import {inject, injectable} from "inversify";
import {Team} from "@/modules/team/entity";
import chance from "@/modules/base/services/chance";
import AIServiceProvider from "@/modules/ai/services/AIServiceProvider";
import PlayerTransferrer from "@/modules/transfer-market/services/PlayerTransferrer";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export default class DirectTransferHandler {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(AIServiceProvider) private aiServiceProvider: AIServiceProvider,
    @inject(PlayerTransferrer) private playerTransferrer: PlayerTransferrer,
  ) {
  }

  public async handle(team: Team) {
    const player = await this.aiServiceProvider.getTransferDecider(team.aiQualityLevel).getTransferTarget(team);

    if (!player) {
      return null;
    }

    let price = player.marketValue * chance.floating(this.configRepository.get('transferMarket.directTransfer.priceRange'));

    await this
      .playerTransferrer
      .transfer(player, team, price);

    return player;
  }
}
